import {Quill} from 'react-quill';

/**
 * Quill bindings are resolved in the order of declaration. Meaning keys with multiple
 * handlers will only fire the first one which matches. Quill's built-in `addBinding`
 * method does not allow the user to set the binding's precedence. This gets around
 * that by modifying internal state of the editor to place our keybinding at the start.
 *
 * See quill documentation for options https://quilljs.com/docs/modules/keyboard/
 */
export function addPrimaryBinding(editor: Quill, options: any) {
  // @ts-ignore bindings isn't part of the public types, but is still accessible.
  editor.keyboard.bindings[options.key].unshift({
    ...options,
  });
}
